import React from 'react'
import styled from 'styled-components'

import type { IconProps } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'

type ReferralCardIconProps = {
  icon: React.FC<IconProps>
} & ClassNameProps

export const ReferralCardIcon: React.FC<ReferralCardIconProps> = ({
  className,
  icon,
}) => {
  const Icon = icon
  return (
    <Root className={className}>
      <Icon size={16} />
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 6px;
  justify-content: center;
  align-items: center;

  border-radius: var(--Buttons-Radius-64-px, 64px);
  background: var(--background-2);
`
